import React from 'react';
import { useLocation } from 'react-router-dom';
import { FaHome, FaEnvelope, FaPhone, FaArrowUp, FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaYoutube, FaPinterest } from 'react-icons/fa';


// Your institute data
const institutes = [
  { id: 'st-pauls', instituteName: "St. Paul's Matric Hr Sec School", location: "V. Kotta Road, Pernambut, Vellore Dist. Tamilnadu 635810",email:"stpaulsschoolpbt@gmail.com" },
  { id: 'st-josephs', instituteName: "St. Joseph's Matric Hr Sec School", location: " Pallalakuppam, Pernambut Taluk Vellore Dist. Tamilnadu 635805",email:"stjosephsschoolpbt@gmail.com" },
  { id: 'agaram', instituteName: 'Agaram Matriculation School', location: " Pallikonda, Vellore Dist. Tamilnadu. 635809",email:"agaramschoolpallikonda@gmail.com" },
  { id: 'trinity', instituteName: 'Trinity Matric Hr Sec School', location: "Gandhi Nagar, Vellore, Tamil Nadu 632006",email:"trinityschoolvlr@gmail.com" },
  { id: 'cap-career', instituteName: 'Captains Career Campus', location: "Veerasamy street, Near bus stand, Pernambut, Vellore, Tamil Nadu 635810",email:"c3neetinstitute@gmail.com" },
  { id: 'nayagi', instituteName: 'Nayagi Institute of Nursing', location: " St Paul's School Campus, V.Kotta Road, Pernambut, Vellore",email:"nayagiinstitute@gmail.com" },
];


const Footer = () => {
  const currentYear = new Date().getFullYear();

  const location = useLocation();

  // Better logic to handle nested URLs and extra slashes
  const pathSegments = location.pathname.split('/').filter(item => item !== "");
  // If the first part is "blog", grab the second part
  const currentId = pathSegments[0]?.toLowerCase() === 'blog' ? pathSegments[1] : null;

  const selectedInstitute = institutes.find(inst => inst.id === currentId);

  //Fallback/Default values for other pages (Home, About, etc.)
  const displayName = selectedInstitute ? selectedInstitute.instituteName : "DNET GROUP";
  const displayLocation = selectedInstitute ? selectedInstitute.location : "Devanayagi Educational Trust, Pernambut";
  const displayEmail = selectedInstitute ? selectedInstitute.email : "info@dnet.com";

  return (
    <footer className="tsk text-white py-5">
      <div className="container">
        <div className="row g-4">
          {/* Column 1 - About */}
          <div className="col-lg-4 col-md-6">
            <div className="footer-logo mb-4">
              <a href="/">
                <img 
                  src="/assets/images/DNET-logo-white.png" 
                  alt="DNET Logo" 
                  className="img-fluid"
                  style={{maxHeight: '60px'}}
                />
              </a>
            </div>
            <p className="mb-4">
              Devanayagi Educational Trust - Committed to providing quality education and nurturing future leaders.
            </p>
            <div className="social-links d-flex gap-4">
              <a href="#" className="text-white">
                <FaFacebook size={20} />
              </a>
              <a href="#" className="text-white">
                <FaTwitter size={20} />
              </a>
              <a href="#" className="text-white">
                <FaInstagram size={20} />
              </a>
              <a href="#" className="text-white">
                <FaLinkedin size={20} />
              </a>
               <a href="#" className="text-white">
                <FaYoutube size={20} />
              </a>
               <a href="#" className="text-white">
                <FaPinterest size={20} />
              </a>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div className="col-lg-4 col-md-6">
            <h5 className="">Quick Links</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <a href="/" className="text-white text-decoration-none">Home</a>
              </li>
              <li className="mb-2">
                <a href="/AboutUs" className="text-white text-decoration-none">About Us</a>
              </li>
              <li className="mb-2">
                <a href="/Programs" className="text-white text-decoration-none">Programs</a>
              </li>
              <li className="mb-2">
                <a href="/Courses" className="text-white text-decoration-none">Courses</a>
              </li>
              <li className="mb-2">
                <a href="/ContactUs" className="text-white text-decoration-none">Contact</a>
              </li>
            </ul>
          </div>

          {/* Column 3 - Contact Info */}
          <div className="col-lg-4 col-md-12">
            <h5 className="mb-0">Contact Information</h5>
            <ul className="list-unstyled">
              <li className="mb-3 d-flex align-items-start">
                <FaHome className="mt-1 me-3" />
                <div>
                  <h6 className="mb-2">{displayName}</h6>
                  <p className="mb-0">{displayLocation}</p>
                </div>
              </li>
              <li className="mb-3 d-flex align-items-start">
                <FaEnvelope className="mt-1 me-3" />
                <div>
                  <h6 className="mb-2">Email Address</h6>
                  <p className="mb-0">{displayEmail}</p>
                </div>
              </li>
              <li className="mb-3 d-flex align-items-start">
                <FaPhone className="mt-1 me-3" />
                <div>
                  <h6 className="mb-2">Phone Number</h6>
                  <p className="mb-0">+91 95003 21010 , +91 77082 13141</p>
                </div>
              </li>
              <li className="d-flex align-items-start">
                <div className="mt-1 me-3">
                  <i className="bi bi-clock"></i>
                </div>
                <div>
                  <h6 className="mb-2">Opening Hours</h6>
                  <p className="mb-0">Monday - Friday: 9:00 AM - 5:00 PM</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="row mt-5">
          <div className="col-12">
            <hr className="my-4" />
            <div className="text-center">
              <p className="mb-0">
                Copyright © {currentYear} Dnetschool.com | All Rights Reserved
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <div className="scroll-to-top">
        <a href="#top" className="btn btn-primary rounded-circle p-3 position-fixed bottom-0 end-0 m-4">
          <FaArrowUp size={20} />
        </a>
      </div>
    </footer>
  );
};

export default Footer;